export type ClaimsTriggerType = 'call' | 'email';

export type ClickEventType = 'click' | 'auxclick';

